const EMAIL_NOT_FOUND_ERROR = 'REQUEST_RESET_FAILURE_404';
const EMAIL_NOT_SENT_ERROR = 'REQUEST_EMAIL_FAILURE_500';

class RequestPasswordResetController {
  constructor(requestPasswordResetService) {
    this.name = 'requestPasswordReset';
    this.requestPasswordResetService = requestPasswordResetService;
    this.uploadHasSucceeded = false;
  }

  requestPasswordReset(){
    this.requestPasswordResetService.requestReset(this.email).then(
      this.onPasswordResetSuccess.bind(this),
      this.onPasswordResetFailure.bind(this)
    );
  }

  onPasswordResetSuccess() {
    this.uploadHasSucceeded = true;
  }

  onPasswordResetFailure(response) {
    this.error = response.status === 404 ? EMAIL_NOT_FOUND_ERROR : EMAIL_NOT_SENT_ERROR;
  }

  removeMessages() {
    delete this.error;
    this.uploadHasSucceeded = false;
  }
}

RequestPasswordResetController.$inject = ['requestPasswordResetService'];

export default RequestPasswordResetController;



// WEBPACK FOOTER //
// ./app/components/requestPasswordReset/requestPasswordReset.controller.js